<template>
  <div class="amazon_edit" style="width: 90%">
    <Breadcrumb></Breadcrumb>
    <div style="text-align: right; margin: 0 0 8px 0; padding-top: 10px">
      <el-button @click="handleSaveForm" size="small" type="primary"
        >保存模板</el-button
      >
    </div>
    <Template
      @save="handleSaveForm"
      @submit="handleSubmit"
      ref="template"
    ></Template>
  </div>
</template>

<script type="text/ecmascript-6">
import Template from './createTemplate.vue'
import Breadcrumb from "@/components/common/Breadcrumb";
export default {
  name: "createTemplate",
  components: { Template, Breadcrumb },
  data() {
    return {
    };
  },
  computed: {
  },
  methods: {
    handleSaveForm(){
      this.$refs['template'].handleSave()
    },
    handleSubmit(){
      let platNo = this.$route.query.platNo;
      if(platNo == '03'){
        this.$router.push('/carry/lazada/lazada');
      }
      else  if(platNo == '05'){
        this.$router.push('/carry/shopee/proTemplate');
      }  else  if(platNo == '10'){
        this.$router.push('/carry/tiktok/proTemplate');
      }
      else{
        this.$router.push('/carry/common/template');
      }
    }
  },
 async mounted() {
  let platName = this.$route.query.platName
  if(platName){
    document.querySelectorAll('.el-breadcrumb__inner')[1].innerHTML =  platName
  }
  },
};
</script>

<style lang="scss" scoped></style>
